module.exports = __webpack_public_path__ + "img/redemption.cef432bc.svg";